import React from 'react';
import { useHistory } from 'react-router';
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';

const PREFIX = 'TopActionBar';

const classes = {
  linkContainer: `${PREFIX}-linkContainer`,
};

const Root = styled('div')(() => ({
  display: 'flex',
  '& a': {
    cursor: 'pointer',
  },
  [`& .${classes.linkContainer}`]: {
    flex: 1,
  },
}));

export default function TopActionBar({
  onBack,
  id,
}: {
  id?: string;
  onBack?: () => void;
}): JSX.Element {
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation('default');
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else {
      history.push('/home');
    }
  };

  const handleCopyReportLink = () => {
    if (!id) return;
    const url = `${window.origin}/combined-reports/${id}?type=sg`;
    navigator.clipboard.writeText(url);
    setOpen(true);
  };

  const renderCopyLink = () => {
    return (
      <div className={classes.linkContainer} style={{ textAlign: 'right' }}>
        <Link onClick={handleCopyReportLink} color="secondary">
          <Typography component="div" color="secondary">
            {t('copy-the-report-link')}
          </Typography>
        </Link>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={open}
          onClose={handleClose}
          autoHideDuration={1000}
          message="Report link copied"
        />
      </div>
    );
  };

  return (
    <Root>
      <div className={classes.linkContainer} style={{ textAlign: 'left' }}>
        <Link onClick={handleGoBack} color="secondary">
          {t('back-to-search-page')}
        </Link>
      </div>
      {id && renderCopyLink()}
    </Root>
  );
}
